import { Create, Edit, List, Show, BulkCreate, StoreItems, DataTable } from "../Components/index.js";

export default [
    {
        path: "/property/store",
        component: DataTable,
        name: "property.store",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/store/create",
        component: Create,
        name: "property.store.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/store/:id/edit",
        component: Edit,
        name: "property.store.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/store/:id/items",
        component: StoreItems,
        name: "property.store.items",
        meta: {
            requiresAuth: true,
        },
    },
];
